import React from "react";
import { useTranslation } from "react-i18next";
import {
  allCoPayments,
  CoPaymentEnum,
  translateKey,
} from "common/enums/CoPaymentEnum";
import { GlobalState } from "store/configure-store";
import { connect } from "react-redux";
import { selectCoPayment } from "store/reducers/patient.reducer";
import { setCoPayment } from "store/actions/patient.actions";
import Card from "@cc/react-components/Card";
import ListGroup from "ui/ListGroup";
import Page from "ui/Page";
import { PV_CO_PAYMENT } from "common/matomo/track-page-view.constants";
import { useTrackPageView } from "common/matomo/track-page-view.hook";

export interface Props {
  coPayment: CoPaymentEnum;
  setCoPayment(coPaymentEnum: CoPaymentEnum): void;
}

const CoPaymentContainer = ({ coPayment, setCoPayment }: Props) => {
  const [t] = useTranslation();

  useTrackPageView(PV_CO_PAYMENT);

  const renderResults = (coPaymentEnums: CoPaymentEnum[]) => {
    return (
      <ListGroup>
        {coPaymentEnums.map((coPaymentEnum, index) => (
          <ListGroup.ItemMobile
            key={index}
            className="text-center font-weight-bold p-4"
            active={coPayment === coPaymentEnum}
            onClick={() => setCoPayment(coPaymentEnum)}
          >
            {t(translateKey(CoPaymentEnum[coPaymentEnum]))}
          </ListGroup.ItemMobile>
        ))}
      </ListGroup>
    );
  };

  return (
    <Page.Scrollable>
      <Page.Body>
        <Card>
          <Card.Header>
            <Card.Title>{t("coPayment.title")}</Card.Title>
          </Card.Header>
        </Card>
        {renderResults(allCoPayments())}
      </Page.Body>
    </Page.Scrollable>
  );
};

const mapStateToProps = (state: GlobalState) => {
  return {
    coPayment: selectCoPayment(state),
  };
};

export default connect(mapStateToProps, { setCoPayment })(CoPaymentContainer);
